import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';

export const useCity = (cityId: string | number) => {
  const [response, setResponse] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchData = useCallback(() => {
    if (cityId) {
      setLoading(true);
      axios
        .get(`/api/cities/${cityId}`)
        .then((response) => setResponse(response.data.data))
        .then(() => setLoading(false));
    }
  }, [cityId]);

  useEffect(() => {
    fetchData();
  }, [cityId, fetchData]);

  return { city: response, loading };
};
